import { Helmet } from "react-helmet";
import PageHero from "../components/reusables/hero/PageHero";
import PrivacyPolicyBody from "../components/privacy-policy/PrivacyPolicyBody";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Learn how FLEXI PAINTERS collects, uses and protects your shared information in accordance with our commitment to privacy and data security."
        />
        <meta
          property="og:description"
          content="Learn how FLEXI PAINTERS collects, uses and protects your shared information in accordance with our commitment to privacy and data security."
        />
        <meta
          property="og:title"
          content="Privacy Policy | Flexi Painters | Professional Painters in Kampala, Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1775970059/flexi_painters_banner_tnrltj.jpg"
        />

        <meta
          name="twitter:title"
          content="Privacy Policy | Flexi Painters | Professional Painters in Kampala, Uganda"
        />
        <meta
          name="twitter:text:title"
          content="Privacy Policy | Flexi Painters | Professional Painters in Kampala, Uganda"
        />
        <meta
          name="twitter:description"
          content="Learn how FLEXI PAINTERS collects, uses and protects your shared information in accordance with our commitment to privacy and data security."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1775970059/flexi_painters_banner_tnrltj.jpg"
        />
        <title>
          Privacy Policy | Flexi Painters | Professional Painters in Kampala,
          Uganda
        </title>
      </Helmet>
      <PageHero
        classes="painter-bg pageHero"
        titleClasses="title uppercase flexi-orange"
        title="Privacy Policy"
      />
      <PrivacyPolicyBody />
    </>
  );
}
